import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarX, ExclamationCircle } from "react-bootstrap-icons";
import { getPublicWebinars } from "../../services/Public";
import Footer from "../../components/Footer/Footer";
import logo from "../../assets/logo.png";
import "./public-common.css";
import "./home.css";
import WebinarItem from "../../components/WebinarItem/webinarItem";
import { IWebinar } from "../../utils/webinar";

export default function Home() {
    const [loading, setLoading] = useState<boolean>(true);
    const [webinars, setWebinars] = useState<IWebinar[]>([]);
    const [error, setError] = useState<boolean>(false);

    useEffect(() => {
        getPublicWebinars()
            .then((res) => {
                if (res.data === undefined) {
                    setError(true);
                    return;
                }
                const list: IWebinar[] = res.data
                    .filter((item: IWebinar) => item.active !== 0)
                    .filter((item: IWebinar) => {
                        const end = new Date(item.end_date);
                        end.setDate(end.getDate() + 1);
                        return Date.now() < end.getTime();
                    });
                setWebinars(list);
            })
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="public-page home-page">
            <main>
                <img src={logo} alt="Logo Maggioli" className="public-logo" />

                <div className="public-hero">
                    <h1>A quale webinar desideri partecipare?</h1>
                    <p>Scegli un evento e completa la registrazione in pochi secondi.</p>
                </div>

                {loading && (
                    <div className="public-spinner">
                        <div className="spinner-border" role="status" />
                    </div>
                )}

                {error && (
                    <div className="public-status danger">
                        <ExclamationCircle />
                        <h2>Impossibile caricare i webinar</h2>
                        <p>Si è verificato un errore nel caricamento dei webinar. Riprova più tardi.</p>
                    </div>
                )}

                {!loading && !error && webinars.length === 0 && (
                    <div className="public-status">
                        <CalendarX />
                        <h2>Nessun webinar in programma</h2>
                        <p>Al momento non ci sono webinar in programma. Torna a trovarci presto!</p>
                    </div>
                )}

                {!loading && !error && webinars.length > 0 && (
                    <div className="webinar-list">
                        {webinars.map((webinar, index) => (
                            <Link key={`${webinar.id}-${index}`} to={`/register/${webinar.id}`}>
                                <WebinarItem webinar={webinar} index={index + 1} interactive />
                            </Link>
                        ))}
                    </div>
                )}
            </main>
            <Footer />
        </div>
    );
}
